export const SET_MOBILE_LAYOUT = 'setMobileLayout';
export const SET_MENU_STATE = 'setMenuState';
export const TOGGLE_MENU_STATE = 'toggleMenu';
